define([
	"dojo/_base/declare",
	"csi/_base/underscore",
	"csi/table/Widget",
	"csi/xml",
	"./_Store",
	"./_TableMixin"
], function(declare,_,Table,xml,_Store,_TableMixin) {

	var	_EnumValueStore = declare(_Store, {
		// String: EnumList url
		urlEnum: null,

		_getResource: function(/*Node*/node, /*LocaleResolver*/lr) {
			// summary: get resource for key from resolver
			return lr.getEnumName(node.Id);
		},

		_resolveData: function(/*Deferred*/dfd) {
			// summary: create items for store from all enabled, non-private classes with explicit Name
			var	enumList = this._store.get(this.urlEnum);
			var	enumValues = this._store.getNodes(enumList.Values);
			var	data = _.map(enumValues, function(enumValue) {
				return this._createNode(xml.enumCreate(enumList.$Name, enumValue.$Name));
			}, this);
			
			dfd.resolve(data);
		}
	});

	return declare([Table,_TableMixin], {
		storeClass: _EnumValueStore,

		_createStore: function(/*Context*/ctx, /*Boolean*/bConfigurable) {
			// summary: create store for view
			var	store = this.inherited(arguments);
			store.urlEnum = this.urlRoot;
			return store;
		}
	});
});